import React, { useState } from "react";
import config from "../../../config";
import ApiDropdown from "../../DropDown/Apidropdown";
import Input from "../../input/input";
import "../Modal2.css";
import { authFetch } from "../../../utils/Security/authFetch";
import axios from "../../../utils/Security/axiosInstance";

import TextArea from "../../TextArea/TextArea";

type ConfirmCloseModalProps = {
  data: any; // Should ideally be typed better
  onConfirm: () => void; // Callback on success
  onCancel: () => void;
};
const storedUsername = localStorage.getItem("username");

const ConfirmCloseModal: React.FC<ConfirmCloseModalProps> = ({
  data,
  onConfirm,
  onCancel,
}) => {
  const [problemCloseDatetime, setProblemCloseDatetime] = useState<string>(
    data.problemCloseDatetime || ""
  );
  const [errorType, setErrorType] = useState<string>(data.errorType || "");
  const [closureCode, setClosureCode] = useState<string>(
    data.closureCode || ""
  );
  const [closedby, setClosedby] = useState<string>(data.closedby || "");
  const [solution, setSolution] = useState<string>(data.solution || "");

  const handleConfirm = async () => {
    if (storedUsername !== null) {
      setClosedby(storedUsername);
    }
    if (!closureCode.trim()) {
      alert("Please enter Closure Code.");
      return;
    }
    if (!solution.trim()) {
      alert("Please enter the Solution.");
      return;
    }
    try {
      const payload = {
        ticketId: data.ticketId,
        errorType,
        closureCode,
        solution,
        closedby: storedUsername || closedby,
        problemCloseDatetime,
      };

      const response = await axios.put(
        `${config.apiBaseUrl}/api/problems/confirmclose`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      alert("Problem closed successfully!");
      onConfirm();
    } catch (error) {
      alert(`Failed to close problem: ${(error as Error).message}`);
    }
  };

  return (
    <div
      className="modal-overlay"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
        padding: "1rem",
      }}
    >
      <div
        className="modal-content"
        style={{
          backgroundColor: "#fff",
          padding: "2rem 2.5rem",
          borderRadius: "12px",
          maxWidth: 450,
          width: "100%",
          boxShadow:
            "0 8px 24px rgba(0, 0, 0, 0.15), 0 2px 8px rgba(0, 0, 0, 0.1)",
          display: "flex",
          flexDirection: "column",
          gap: "1.5rem",
          fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        }}
      >
        <h2
          style={{
            margin: 0,
            fontWeight: "600",
            fontSize: "1.5rem",
            color: "#333",
          }}
        >
          Add Journal
        </h2>
        <Input
          type="datetime-local"
          label="Problem Close Date/Time"
          value={problemCloseDatetime}
          onChange={(val) => setProblemCloseDatetime(val)}
          style={{ width: "100%" }}
        />
        <ApiDropdown
          api="Errors"
          labelKey="type"
          valueKey="type"
          label="Error Type"
          onChange={(val) => setErrorType(String(val))}
        />
        <ApiDropdown
          api="ClosureCodesProblem"
          labelKey="name"
          valueKey="name"
          label="Closure Code"
          value={closureCode}
          onChange={(val) => setClosureCode(String(val))}
        />

        <TextArea
          label="Solution"
          value={solution}
          onChange={(val) => setSolution(val)}
          style={{ width: "100%" }}
        />
        <Input
          type="text"
          label="Closed By"
          value={storedUsername || ""}
          onChange={(val) => setClosedby(val)}
          style={{ width: "100%" }}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "1rem",
            marginTop: "1rem",
          }}
        >
          <button
            onClick={onCancel}
            style={{
              padding: "0.5rem 1.2rem",
              borderRadius: "6px",
              border: "1px solid #ccc",
              backgroundColor: "#fff",
              color: "#444",
              cursor: "pointer",
              fontWeight: 500,
              transition: "background-color 0.2s ease",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor = "#f0f0f0")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor = "#fff")
            }
          >
            Cancel
          </button>
          <button
            onClick={handleConfirm}
            style={{
              padding: "0.5rem 1.5rem",
              borderRadius: "6px",
              border: "none",
              backgroundColor: "#f97316",
              color: "white",
              cursor: "pointer",
              fontWeight: 600,
              boxShadow: "0 4px 8px rgba(249, 115, 22, 0.4)",
              transition: "background-color 0.2s ease",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor = "#c4510b")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor = "#f97316")
            }
          >
            Yes, Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmCloseModal;
